export const totalSettlement = (data: object) => {
  const sum = Object.values(data).reduce(
    (accumulator, currentValue) => accumulator + currentValue,
    0
  );
  return sum;
};
